//angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

//local
import { SecurityConfig } from '@app/core';
import { ApiConstants, HttpResult, PollyHttpHelper } from '@app/shared';
import { RoomContentPropertyDto, CreateRoomContentRequest, UpdateRoomContentRequest } from '@app/catalog';

@Injectable({
    providedIn: 'root'
})
export class RoomContentHttpService 
{
    constructor(
      private http: HttpClient, 
      private applicationConfig: SecurityConfig) {    
    }


    public getProperties(roomContentId: string, programId?: string, projectId?: string): HttpResult<RoomContentPropertyDto> 
    {
      let params = new HttpParams();

      if(programId) {
        params = params.set('programId', programId);
      }

      if(projectId) {
        params = params.set('projectId', projectId);
      }

      let serviceUri = `${this.applicationConfig.applicationUri}/v2/catalog/roomcontent/${roomContentId}`;
            
      console.log(`GET: ${serviceUri}`); 
      
      return PollyHttpHelper.Invoke('GET', () => this.http.get<RoomContentPropertyDto>(serviceUri, { headers: ApiConstants.DefaultHeaders, params }));
    }

    public create(request: CreateRoomContentRequest): HttpResult<Object> 
    {      
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/roomcontent`;
            
      console.log(`POST: ${serviceUri}`); 
      console.log(request);
            
      return PollyHttpHelper.Invoke('POST', () => this.http.post<Object>(serviceUri, request, { headers: ApiConstants.DefaultHeaders }));
    }

    public update(roomId: string, request: UpdateRoomContentRequest): HttpResult<Object> 
    {      
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/roomcontent/${roomId}`;
            
      console.log(`PUT: ${serviceUri}`); 
      console.log(request);
            
      return PollyHttpHelper.Invoke('PUT', () => this.http.put<Object>(serviceUri, request, { headers: ApiConstants.DefaultHeaders }));
    }
}